export {
  default as divingBoard,
  ReactComponent as DivingBoard,
} from '@assets/icons/features-and-amenities/diving-board.svg'    
